import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import { animations } from "helpers/animations";
import { height } from "./CustomerView";
import { CustomerDocumentation } from "./contracts/CustomerDocumentation";
import { useSelector } from "react-redux";
import { CustomerForm } from "./accounts/CustomerForm";
import { CustomerOrderForm } from "./orders/CustomerOrderForm";
import { CustomerCycleForm } from "./cycles/CustomerCycleForm";
import { CustomerConditionsForm } from "./conditions/CustomerConditionsForm";
import { CyclesList } from "./cycles/CyclesList";
import { useScrollTop } from "hooks/useScrollTop";
import { InfoChildren } from "./InfoChildren";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { CustomerCreditConditionsForm } from "./creditConditions/CustomerCreditConditionsForm";

export const InformationColumn = () => {
  const { viewCount, account, addMode, editCustomer } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  useScrollTop(account);
  const [selectComponent, setSelectComponent] = useState({
    label: "",
    component: null,
    border: null,
  });

  const { label, component, border } = selectComponent;

  useEffect(() => {
    let timeoutId;
    
    switch (viewCount) {
      case 0:
        setSelectComponent({
          label: '',
          component: <div className={animations.fadeIn} style={{
            height: "100%",
            width: "100%",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center', 
            transition: 'all .3s ease-in-out',
          }}></div>,
        });
        break;
  
      case 1:
          setSelectComponent({
            label: addMode
              ? "Registrar nueva cuenta"
              : `Información de${ editCustomer ? 'l cliente' : ' la cuenta' }`,
            component: <CustomerForm />,
          });
        break;
  
      case 2:
          setSelectComponent({
            label: "Generar pedido",
            component: <CustomerOrderForm />,
          });
        break;
  
      case 3:
          setSelectComponent({
            label: "Programar Ciclo",
            component: <CustomerCycleForm />,
          });
        break;
  
      case 4:
        timeoutId = setTimeout(() => {
          setSelectComponent({
            label: "Ciclos",
            component: <CyclesList />,
          });
        }, 300);
        break;
  
      case 5:
          setSelectComponent({
            label: "Condiciones Mayoristas",
            component: <CustomerConditionsForm />,
          });
        break;
  
      case 6:
          setSelectComponent({
            label: "Condiciones de Credito",
            component: <CustomerCreditConditionsForm />,
          });
        break;

      case 7:
          setSelectComponent({
            label: "Documentación",
            component: <CustomerDocumentation />,
          });
        break;

      case -1:
          setSelectComponent({
            label: "Cargando",
            component: <LoadingComponent />,
          });
        break;
  
      default:
        break;
    }
  
    return () => clearTimeout(timeoutId);
  }, [viewCount, addMode, editCustomer]);
  

  return (
    <Grid
      item
      xs={12}
      md={8}
      lg={7}
      className={animations.fadeIn}
      style={{
        animationDelay: ".5s",
      }}
    >
      <InfoChildren
        label={label}
        height={height}
        border={border}
        component={component}
      />
      
    </Grid>
  );
};
